<template>
  <el-row style="width: 100%;margin-top: 87px;">
    <!--  轮播图  -->
    <el-row style="height: 660px;">
      <el-carousel :interval="4000" trigger="click" arrow="always" height="660px">
        <el-carousel-item v-for="(item, i) in imgList" :key="i">
          <el-row :style="{backgroundImage: 'url(' + item + ')', width: '100%', height: '100%', backgroundSize:'100% 100%', backgroundRepeat:'no-repeat'}">
          </el-row>
        </el-carousel-item>
      </el-carousel>
    </el-row>
    <el-row style="width: 64%;margin-left: 18%;margin-top: 40px;display: flex;">
      <el-col style="width: 26%;border-right: 1px solid #5e5e5e;">
        <el-row v-for="(data, i) in dataList" :key="i" :class="i === selMenu ? 'menu-class-hover' : 'menu-class'" @click.native="clickMenu(i)">
          {{data.name}}
        </el-row>
      </el-col>
      <el-col style="width: 67%;margin-left: 7%;text-align: left;">
        <slot>
        </slot>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
export default {
  name: 'IntroducePage',
  props: ['selId', 'params'],
  data() {
    return {
      dataList: [
        { id: 21, name: '公司简介', component: '/short_introduce'},
        { id: 22, name: '企业文化', component: '/culture'},
        { id: 23, name: '资质荣誉', component: '/honor'},
        { id: 24, name: '核心团队', component: '/team'}
      ],
      selMenu: 0,
      imgList: [require('../../assets/img/introduce/introduce.jpg')],
      dict: {'/short_introduce': 0, '/culture': 1, '/honor': 2, '/team': 3}
    }
  },
  created() {
    let ind = this.dict[this.$route.path]
    if (ind > -1) {
      this.selMenu = ind
    }
  },
  methods: {
    clickMenu(i) {
      if (this.selMenu !== i) {
        this.$router.push(this.dataList[i].component)
      }
    }
  }
}
</script>

<style scoped>
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }
  .menu-class {
    width: 85%;
    margin-top: 10px;
    height: 40px;
    line-height: 40px;
    background-color: #efefef;
    color: #000000;
    cursor: pointer;
  }
  .menu-class-hover {
    width: 85%;
    margin-top: 10px;
    height: 40px;
    line-height: 40px;
    background-color: #00bf86;
    color: #ffffff;
    cursor: pointer;
  }
  .menu-class:hover {
    background-color: #00bf86;
    color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/components/introduce/IntroducePage.vue